import React, { useEffect, useState } from 'react';
import './App.css';

function Contact() {
    useEffect(() => { window.scrollTo(0, 0); document.title = 'Contact | SPCheapCars'; }, []);

    const primaryOrange = "#ff8e18";
    const trustNavy = "#1c2e4a";

    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < 992);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const glassDark = {
        background: 'rgba(255,255,255,0.07)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        border: '1px solid rgba(255,255,255,0.13)',
        borderRadius: '16px',
    };

    const heroTexture = [
        'repeating-linear-gradient(125deg, transparent 0px, transparent 16px, rgba(255,255,255,0.06) 16px, rgba(255,255,255,0.06) 17px)',
        'repeating-linear-gradient(35deg, transparent 0px, transparent 32px, rgba(255,142,24,0.045) 32px, rgba(255,142,24,0.045) 33px)',
        'radial-gradient(ellipse at 70% 0%, rgba(255,142,24,0.1) 0%, transparent 50%)',
        'linear-gradient(180deg, rgba(28,46,74,0) 0%, rgba(15,26,43,0.5) 100%)'
    ].join(', ');

    const schedule = [
        { day: 'Luni - Vineri', time: '10:00 - 18:00' },
        { day: 'Sâmbătă',       time: '10:00 - 14:00' },
        { day: 'Duminică',      time: '10:00 - 14:00' }
    ];

    const contactMethods = [
        {
            icon: 'bi-telephone-fill', label: 'Telefon',
            value: '0741 811 511', href: 'tel:0741811511',
            desc: 'Apelează direct pentru răspuns imediat.',
            badge: 'Sună acum', chipClass: 'ip-chip--tel', external: false
        },
        {
            icon: 'bi-whatsapp', label: 'WhatsApp',
            value: '0741 811 511',
            href: 'https://wa.me/40741811511?text=' + encodeURIComponent('Salut! Sunt interesat de o mașină.'),
            desc: 'Răspuns rapid, oricând, inclusiv în weekend.',
            badge: 'Mesaj', chipClass: 'ip-chip--wa', external: true
        },
        {
            icon: 'bi-envelope-fill', label: 'Email',
            value: 'contact@spcheapcars.ro', href: 'mailto:contact@spcheapcars.ro',
            desc: 'Răspundem în maxim 24 de ore.',
            badge: 'Email', chipClass: 'ip-chip--mail', external: false
        }
    ];

    return (
        <div style={{ background: '#f0f4f9', minHeight: '100vh' }}>

            {/* ══════════════════════════════════════════════════════════════
                SECTION 1 — HERO
            ══════════════════════════════════════════════════════════════ */}
            <div className="position-relative page-hero" style={{ background: trustNavy, paddingTop: isMobile ? '32px' : '120px', paddingBottom: isMobile ? '48px' : '80px' }}>
                <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: heroTexture }}></div>
                <div className="container text-center text-white position-relative">
                    <div style={{
                        display: 'inline-block', background: `${primaryOrange}22`,
                        border: `1px solid ${primaryOrange}55`, color: primaryOrange,
                        fontSize: '0.65rem', fontWeight: '700', textTransform: 'uppercase',
                        letterSpacing: '3px', padding: '5px 16px', borderRadius: '40px', marginBottom: '18px'
                    }}>RĂSPUNS RAPID</div>
                    <h1 style={{
                        fontWeight: '900', letterSpacing: isMobile ? '1px' : '3px',
                        fontSize: isMobile ? '2rem' : 'clamp(2.2rem, 5vw, 3.5rem)',
                        textTransform: 'uppercase', color: '#ffffff', lineHeight: '1.15', marginBottom: '12px'
                    }}>Contactează-ne</h1>
                    <div style={{ width: '50px', height: '3px', background: primaryOrange, margin: '0 auto 16px', borderRadius: '2px' }}></div>
                    <p style={{ opacity: 0.55, maxWidth: '460px', margin: '0 auto 32px', fontSize: isMobile ? '0.95rem' : '1.05rem', lineHeight: '1.7' }}>
                        Suntem la un telefon distanță. Alege metoda preferată.
                    </p>

                    {/* Glass stat pills */}
                    <div className="d-flex flex-wrap justify-content-center" style={{ gap: '12px' }}>
                        {[
                            { big: 'Instant', label: 'Apel Direct', icon: 'bi-telephone-fill' },
                            { big: 'Non-Stop', label: 'WhatsApp', icon: 'bi-whatsapp' },
                            { big: '24h', label: 'Răspuns Email', icon: 'bi-envelope-fill' }
                        ].map((s, i) => (
                            <div key={i} style={{ ...glassDark, padding: isMobile ? '12px 20px' : '14px 28px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <i className={`bi ${s.icon}`} style={{ color: primaryOrange, fontSize: '1.1rem' }}></i>
                                <div style={{ textAlign: 'left' }}>
                                    <div style={{ color: '#fff', fontWeight: '700', fontSize: isMobile ? '1rem' : '1.15rem', lineHeight: 1 }}>{s.big}</div>
                                    <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: '0.8px', marginTop: '2px' }}>{s.label}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ══════════════════════════════════════════════════════════════
                SECTION 2 — CONTACT METHODS (light)
            ══════════════════════════════════════════════════════════════ */}
            <div className="ip-section">
                <div className="container">
                    <div className="ip-header text-center">
                        <span className="ip-eyebrow">CONTACT DIRECT</span>
                        <h2 className="ip-title">Alege Metoda Preferată</h2>
                    </div>

                    <div className="row g-3">
                        {contactMethods.map((m, i) => (
                            <div className="col-12 col-md-4" key={i}>
                                <a href={m.href}
                                    target={m.external ? '_blank' : undefined}
                                    rel={m.external ? 'noreferrer' : undefined}
                                    className="ip-card ip-card--link"
                                >
                                    <div className="ip-tile">
                                        <i className={`bi ${m.icon}`}></i>
                                    </div>
                                    <div>
                                        <div className="d-flex align-items-center gap-2 mb-1">
                                            <h6 className="ip-card-title mb-0">{m.label}</h6>
                                            <span className={`ip-chip ${m.chipClass}`}>{m.badge}</span>
                                        </div>
                                        <div className="ip-card-value">{m.value}</div>
                                        <p className="ip-card-text">{m.desc}</p>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ══════════════════════════════════════════════════════════════
                SECTION 3 — MAP + ADDRESS + SCHEDULE (dark)
            ══════════════════════════════════════════════════════════════ */}
            <div className="ip-section ip-section--dark">
                <div className="container position-relative">
                    <div className="row align-items-stretch g-4 g-lg-5">

                        {/* ── Map ── */}
                        <div className="col-12 col-lg-7">
                            <div className="ip-map-frame">
                                <iframe
                                    title="Locatie SPCheapCars Timisoara"
                                    src="https://maps.google.com/maps?q=45.7731,21.1977&z=16&output=embed"
                                    allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>
                        </div>

                        {/* ── Info panel ── */}
                        <div className="col-12 col-lg-5">
                            <div className="ip-card-dark h-100 d-flex flex-column justify-content-center">

                                {/* Address */}
                                <div className="mb-4">
                                    <div className="d-flex align-items-center gap-3 mb-3">
                                        <div className="ip-tile ip-tile--orange ip-tile--sm">
                                            <i className="bi bi-geo-alt-fill"></i>
                                        </div>
                                        <div>
                                            <h5 className="ip-item-title mb-1" style={{ fontSize: '1rem' }}>SPCheapCars Timișoara</h5>
                                            <p className="ip-item-sub mb-0" style={{ fontSize: '0.82rem' }}>
                                                Str. Grigore Alexandrescu 121, 300369
                                            </p>
                                        </div>
                                    </div>
                                    <a href="https://www.google.com/maps/dir//45.7731,21.1977"
                                        target="_blank" rel="noreferrer"
                                        className="ip-btn ip-btn--orange ip-btn--sm"
                                    >
                                        <i className="bi bi-cursor-fill"></i> Navighează
                                    </a>
                                </div>

                                <div className="ip-divider my-3"></div>

                                {/* Schedule */}
                                <div>
                                    <div className="d-flex align-items-center gap-3 mb-3">
                                        <div className="ip-tile ip-tile--soft ip-tile--sm">
                                            <i className="bi bi-clock-fill"></i>
                                        </div>
                                        <h5 className="ip-item-title mb-0" style={{ fontSize: '1rem' }}>Program</h5>
                                    </div>
                                    {schedule.map((s, i) => (
                                        <div key={i} className="ip-schedule-row">
                                            <div className="ip-schedule-day">
                                                <span className="ip-dot"></span>
                                                {s.day}
                                            </div>
                                            <span className="ip-schedule-time">{s.time}</span>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Contact;
